import React, { useEffect, useState, useCallback } from 'react';
import api from '../api';
import { Header } from './Dashboard';

export default function Support() {
  const [tickets, setTickets] = useState([]);
  const [filter, setFilter] = useState('');
  const [active, setActive] = useState(null);

  const load = useCallback(async () => {
    const q = filter ? `?status=${filter}` : '';
    const d = await api.get(`/admin/tickets${q}`);
    setTickets(d.tickets);
  }, [filter]);
  useEffect(() => { load(); }, [load]);

  return (
    <div>
      <Header title="Support Tickets" sub="Reply to users and resolve their issues" />
      <div style={{ display: 'flex', gap: 12, marginBottom: 16 }}>
        <select className="input" style={{ maxWidth: 180 }} value={filter} onChange={(e) => setFilter(e.target.value)}>
          <option value="">All</option>
          <option value="open">Open</option>
          <option value="resolved">Resolved</option>
        </select>
      </div>
      <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
        <table>
          <thead><tr><th>User</th><th>Title</th><th>Status</th><th>Updated</th><th></th></tr></thead>
          <tbody>
            {tickets.map((t) => (
              <tr key={t._id}>
                <td style={{ color: '#fff' }}>{t.user?.name || '—'}<div style={{ fontSize: 12, color: 'var(--text-muted)' }}>+{t.user?.phone}</div></td>
                <td>{t.title}</td>
                <td><span className={`badge ${t.status === 'resolved' ? 'incomplete' : 'active'}`}>{t.status}</span></td>
                <td>{new Date(t.updatedAt).toLocaleString()}</td>
                <td><button className="btn sm" onClick={() => setActive(t._id)}>Open</button></td>
              </tr>
            ))}
            {tickets.length === 0 ? <tr><td colSpan={5} style={{ textAlign: 'center', padding: 30 }}>No tickets.</td></tr> : null}
          </tbody>
        </table>
      </div>

      {active ? <TicketModal id={active} onClose={() => setActive(null)} onChanged={load} /> : null}
    </div>
  );
}

function TicketModal({ id, onClose, onChanged }) {
  const [ticket, setTicket] = useState(null);
  const [reply, setReply] = useState('');
  const [busy, setBusy] = useState(false);

  const load = useCallback(async () => {
    const d = await api.get(`/admin/tickets/${id}`);
    setTicket(d.ticket);
  }, [id]);
  useEffect(() => { load(); }, [load]);

  const send = async () => {
    if (!reply.trim()) return;
    setBusy(true);
    try { const d = await api.post(`/admin/tickets/${id}/reply`, { message: reply.trim() }); setTicket(d.ticket); setReply(''); onChanged(); }
    finally { setBusy(false); }
  };
  const resolve = async (reopen) => {
    const d = await api.patch(`/admin/tickets/${id}/resolve`, { reopen });
    setTicket(d.ticket); onChanged();
  };

  const resolved = ticket?.status === 'resolved';

  return (
    <div style={styles.backdrop} onClick={onClose}>
      <div className="card" style={styles.modal} onClick={(e) => e.stopPropagation()}>
        {!ticket ? <div>Loading…</div> : (
          <>
            <div style={styles.head}>
              <div>
                <strong style={{ fontSize: 17 }}>{ticket.title}</strong>
                <div style={{ color: 'var(--text-muted)', fontSize: 13 }}>{ticket.user?.name} · +{ticket.user?.phone}</div>
              </div>
              <span className={`badge ${resolved ? 'incomplete' : 'active'}`}>{ticket.status}</span>
            </div>
            <div style={styles.thread} className="scrollbar">
              {ticket.messages.map((m) => (
                <div key={m._id} style={{ display: 'flex', justifyContent: m.from === 'admin' ? 'flex-end' : 'flex-start', margin: '8px 0' }}>
                  <div style={{ ...styles.bubble, ...(m.from === 'admin' ? styles.bubbleAdmin : styles.bubbleUser) }}>
                    {m.from === 'admin' ? <div style={styles.tag}>YOU</div> : null}
                    {m.mediaUrl ? (
                      m.mediaType === 'video'
                        ? <video src={m.mediaUrl} controls style={styles.media} />
                        : <img src={m.mediaUrl} alt="" style={styles.media} />
                    ) : null}
                    {m.text ? <div>{m.text}</div> : null}
                  </div>
                </div>
              ))}
            </div>
            {!resolved ? (
              <div style={styles.replyRow}>
                <input className="input" placeholder="Type a reply…" value={reply} onChange={(e) => setReply(e.target.value)} onKeyDown={(e) => e.key === 'Enter' && send()} />
                <button className="btn" onClick={send} disabled={busy}>Send</button>
                <button className="btn green" onClick={() => resolve(false)}>Resolve</button>
              </div>
            ) : (
              <div style={styles.replyRow}>
                <div style={{ flex: 1, color: 'var(--text-muted)' }}>✓ Resolved — the user can no longer message.</div>
                <button className="btn muted" onClick={() => resolve(true)}>Reopen</button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}

const styles = {
  backdrop: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 20, padding: 20 },
  modal: { width: 620, maxWidth: '95vw', maxHeight: '85vh', display: 'flex', flexDirection: 'column' },
  head: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingBottom: 12, borderBottom: '1px solid var(--border)' },
  thread: { flex: 1, overflowY: 'auto', padding: '12px 0', minHeight: 200 },
  bubble: { maxWidth: '78%', padding: '10px 14px', borderRadius: 14, fontSize: 14 },
  bubbleUser: { background: 'var(--card-alt)', color: 'var(--text)' },
  bubbleAdmin: { background: 'var(--primary)', color: '#fff' },
  tag: { fontSize: 10, fontWeight: 800, opacity: 0.8, marginBottom: 4 },
  media: { maxWidth: 220, borderRadius: 10, marginBottom: 6, display: 'block' },
  replyRow: { display: 'flex', gap: 8, paddingTop: 12, borderTop: '1px solid var(--border)' },
};
